import { makeStyles } from 'tss-react/mui';
import {
  BUTTON_GREY_4,
  LINK_RED,
  SECONDARY_BLUE,
  SECONDARY_BLUE_2_TRANSPARENT_10,
  SECONDARY_BLUE_2_TRANSPARENT_40,
  SECONDARY_BLUE_3,
  TABS_BLUE,
  WHITE,
} from 'utilities/colors';
import { VERTICAL_SCROLL_STYLE } from 'themes/defaultMuiTheme';

export const useStyles = makeStyles()((theme, { isSlideCard }) => ({
  root: {
    display: 'grid',
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#ccc',
      },
      '&:hover fieldset': {
        borderColor: '#aaa',
      },
      '&.Mui-focused fieldset': {
        border: `1px solid ${SECONDARY_BLUE_2_TRANSPARENT_40}`,
      },
      '& input': {
        height: '2em',
        padding: '0.25rem',
      },
    },
  },
  editableSelect: {
    width: '100%',
  },
  removeButton: {
    color: LINK_RED,
    cursor: 'pointer',
    fontSize: '1rem',
    marginLeft: 'auto',
    marginRight: '0.5rem',
    alignSelf: 'center',
  },
  addToSlideButton: {
    height: '2.5rem',
    color: WHITE,
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  customInput: {
    width: '15rem',
    height: '1.75rem',
    paddingLeft: '0.75rem',
    backgroundColor: 'white',
    border: '1px solid #ccc',
    borderRadius: '0.25rem',
  },
  centered: {
    position: 'absolute',
    top: '60%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  tabs: {
    '.Mui-selected': {
      color: TABS_BLUE,
    },
    position: 'sticky',
    top: 0,
    backgroundColor: 'white',
    alignItems: 'center',
  },
  button: {
    margin: '5px 0',
    marginLeft: 'auto',
    fontSize: '0.75rem',
    padding: '3px 10px',
  },
  viewSimilarSlidesLinkBox: {
    cursor: 'pointer',
    margin: '0.5rem 0',
    width: '100%',
    border: `1px solid ${SECONDARY_BLUE_3}`,
    borderRadius: '0.25rem',
    padding: '0.5rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  viewSimilarSlidesLink: {
    color: SECONDARY_BLUE_3,
    marginRight: '0.375rem',
    lineHeight: 0.75,
  },
  linkIcon: {
    fontSize: '0.875rem',
    color: SECONDARY_BLUE_3,
    opacity: '0.6',
  },
  link: {
    color: 'inherit',
    '&:hover': {
      color: SECONDARY_BLUE_3,
      textDecoration: 'underline',
    },
  },
  tableRow: {
    display: 'flex',
    alignItems: 'center',
    height: '2rem',
    borderBottom: '1px solid #0000001A',

    '&:last-child': {
      borderBottom: 'none',
    },
  },
  valueCell: {
    borderBottom: 'none',
    flex: 3.5,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: 250,
    padding: '0.6rem',
  },
  labelCell: {
    borderBottom: 'none',
    flex: 1.5,
    width: '5rem',
    padding: '0.75rem',
  },
  editCell: {
    borderBottom: 'none',
    flex: 1,
    width: '2rem',
    textAlign: 'right',
    padding: '0.75rem',
  },
  table: {
    border: '2px solid #0000001A',
    borderRadius: '0.5rem',
  },
  tableContainer: {
    boxShadow: 'none',
    border: 'none',
    ...VERTICAL_SCROLL_STYLE,
    overflowY: isSlideCard ? 'auto' : 'hidden',
  },
  editLink: {
    cursor: 'pointer',
    color: BUTTON_GREY_4,
    fontSize: '0.75rem',
  },
  editableInput: {
    width: '15rem',
    height: '1rem',
    padding: '0.5rem',
    margin: '0.5rem',
  },
  actionButton: {
    backgroundColor: 'transparent',
    color: 'white',
    width: '3rem',
    margin: '0 -0.5rem 0 0.75rem',
    padding: '0.25rem',
    minWidth: '3.5rem',
    height: '1.5rem',
    textTransform: 'none',
    fontSize: '0.75rem',
    '&:hover': {
      backgroundColor: SECONDARY_BLUE_2_TRANSPARENT_10,
    },
  },
  saveButton: {
    color: SECONDARY_BLUE,
  },
  cancelButton: {
    color: LINK_RED,
  },
}));
